import {Header } from "../components/Header";
import {LanguageSelector} from "../components/LanguageSelector";
import {HeroSection} from "../components/HeroSection";
import {useLanguage} from "../context/LanguageContext";
import {translations} from "../utils/translations";
import {Section} from "../components/Section";
import React from "react";
import {Footer} from "../components/Footer";

function ContactForm({ t }: any) {

    return (
        <Section>
            <h1>{t.contact.title}</h1>
            <p>{t.contact.description}</p>
            <form
                    action="https://formspree.io/f/mgvkydnq"
                    method="POST"
                    className="contact-form"
                >
                    <input type="hidden" name="_redirect" value="https://marttech.io/thank-you" />
                    <label>
                        {t.contact.name}
                        <input type="text" name="name" required />
                    </label>
                    <label>
                        {t.contact.email}
                        <input type="email" name="email" required />
                    </label>
                    <label>
                        {t.contact.message}
                        <textarea name="message" rows={5} required></textarea>
                    </label>
                    <button type="submit">{t.contact.send}</button>
                </form>
        </Section>
    );
}

export function ContactPage() {
    const { lang } = useLanguage();
    const t = translations[lang];
    return (
        <main className="static-page">
            <LanguageSelector />
            <Header t={t} isBackButtonVisible={true} />
            <HeroSection t={t} />
            <ContactForm t={t} />
            <Footer t={t} />
        </main>
    );
}
